import { useState, useEffect } from "react";
import { fetchDepartmentCall } from "./labRequestService";
import { errorToast } from "../../../components/toastmessage/toastmessage";
import { removeDuplicates } from "../../../utils/helper";
// import { useNavigate } from 'react-router-dom';
// import { successToast, errorToast } from "../../../components/toastmessage/toastmessage";


const useLabRequestHook = (initialState) => {
    // const navigate = useNavigate();
    const [departmentState, setDepartmentState] = useState(initialState);
    const [testNamesState, setTestNamesState] = useState(initialState);
    const [selectedRows, setSelectedRows] = useState([]);

    const handleRowClick = (newSelection) => {
        setSelectedRows(newSelection);
    };
   

    const fetchDepartments = async () => {
        try {
            let { data: { result }, status } = await fetchDepartmentCall();
            const uniqueArray = await removeDuplicates(result, 'departmentName');
            if (status === 200) setDepartmentState(uniqueArray)
        }
        catch (e) {
            errorToast("Failed To fetch Department")
        }

    }

    const handleChange = (e) => {
        const filteredTests = departmentState?.filter((test) => test?.departmentID === e?.target.value);
        setTestNamesState(filteredTests)

    }
    useEffect(() => {
        fetchDepartments()
    }, [])


    return {
        departmentState,
        testNamesState,
        selectedRows,
        handleChange,
        handleRowClick,

    }


};


export default useLabRequestHook;
